import Image, { ImageProps } from 'next/image'

import { theme } from '@theme'

export function ImageWithPlaceholder({ ...property }: ImageProps) {
  return (
    <Image {...property} placeholder={theme.newColors.placeholderLightGrey} />
  )
}
